import {PointsExpirationList} from "../point-expiration/PointsExpirationList";

const AgencyPointSettings = props => {

  //console.log(props)
  const {
    value,
  } = props

  const pointTypes = tangibleFields.render({
    type: 'combo-box',
    name: 'tgbl_cred_agency_point_types',
    value: value.point_types,
    multiple: true,
    isAsync: true,
    ajaxAction: 'tgbl_get_terms_ajax',
    asyncArgs: {
      content_type: 'tgbl_cred_point_type'
    },
    label: 'Point Types',
    description: 'The point types relevant to this accrediting agency.',

  })

  window.pointss = pointTypes;

  return (
    <>
      <div className="tgbl-agency-point_types tgbl-field-block">
        { pointTypes }
      </div>
      <PointsExpirationList
        point_types_field={'tgbl_cred_agency_point_types'}
        value={value.point_expirations?? []}
      />
    </>
  )
}

export { AgencyPointSettings }
